import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useStoreApi } from '../store/storeProvier';
import Lazyload from '../lazyload';
import { useLatest } from '../hooks';

var Impression = function Impression(_a) {
  var children = _a.children,
      style = _a.style,
      height = _a.height,
      dynamic = _a.dynamic,
      props = __rest(_a, ["children", "style", "height", "dynamic"]);

  var _useStoreApi = useStoreApi(),
      setState = _useStoreApi.setState,
      getState = _useStoreApi.getState;

  var onVisibleChange = function onVisibleChange(visible) {
    var _a;

    (_a = props === null || props === void 0 ? void 0 : props.onImpression) === null || _a === void 0 ? void 0 : _a.call(props, visible, {
      config: props,
      setState: setState,
      getState: getState
    });
  };

  var heightRef = useLatest(height);
  var currentHeight = useMemo(function () {
    if (typeof heightRef.current === 'function') {
      return heightRef.current(props);
    }
  }, [props]);
  return _jsx(Lazyload, Object.assign({
    onChange: onVisibleChange,
    style: style,
    height: currentHeight,
    dynamic: dynamic
  }, {
    children: children
  }));
};

export default Impression;